module.exports = __webpack_public_path__ + "static/img/pear.ddf9fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/index/story/pear.png
// module id = s5uh
// module chunks = 1